import apiConfig from "constants/apiConfig";
import { Brand, BrandListPayload, BrandListResponse, GenerateBrandResponse, NewBrand } from "types/brand";
import axiosClient from "utils/axiosClient";

export const fetchBrands = async (agencyId: string, payload: BrandListPayload): Promise<BrandListResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_BRANDS.url.replace('<agencyId>', agencyId), { params: { ...payload } });
    return response.data;
}

export const fetchBrand = async (agencyId: string, brandId: number): Promise<Brand> => {
    const response = await axiosClient.get(apiConfig.FETCH_BRAND.url.replace('<agencyId>', agencyId).replace('<brandId>', String(brandId)));
    return response.data.brand;
}

export const createNewBrand = async (agencyId: string, payload: NewBrand) => {
    const formData = new FormData();

    for (let [key, value] of Object.entries(payload)) {
        formData.append(key, value)
    }

    const response = await axiosClient.post(apiConfig.CREATE_BRAND.url.replace('<agencyId>', agencyId), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}

export const generateBrandDetails = async (agencyId: string, name: string): Promise<GenerateBrandResponse> => {
    const response = await axiosClient.post(
        apiConfig.GENERATE_BRAND.url.replace('<agencyId>', agencyId),
        { name }
    );
    return response.data;
}

export const updateBrand = async (agencyId: string, brandId: number | string, payload: NewBrand) => {

    const formData = new FormData();

    for (let [key, value] of Object.entries(payload)) {
        formData.append(key, value)
    }

    formData.append("_method", "PUT");

    const response = await axiosClient.post(apiConfig.UPDATE_BRAND.url.replace('<agencyId>', agencyId).replace('<brandId>', String(brandId)), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response.data;
}